<script lang="ts">
  import type { Snippet } from 'svelte'
  import type { Category } from '../categories'
  import { PageCategory, setPageCategory } from '../pageCategory'

  let { category, children }: { category: Category; children: Snippet } = $props()

  setPageCategory(new PageCategory(() => category))
</script>

{@render children()}
